<div class="w-100 h-100 d-flex flex-column">
  <div class="title-container">
    <span class="create-offer-title mb-3">{{'createOffer.external.enterExternalCoverage' |translate}}</span>
  </div>

  <ng-scrollbar visibility="hover" class="w-100 flex-shrink-1">
    <div class="inner-content-container">

      <app-external-insurer-form></app-external-insurer-form>
      <hr>
      <app-coverage-information [maxCoverage]="maxCoverage"></app-coverage-information>
      <hr>
      <app-premium-information-form></app-premium-information-form>
      <hr>
      <app-offer-file-upload (uploadInProgress)="sendUploadStatus($event)"></app-offer-file-upload>

    </div>

  </ng-scrollbar>
</div>

